import { Component, OnInit, Output, EventEmitter, Input, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { AuthorizationRequest } from '@core/model';
import { noWhiteSpaceValidator } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-auth-request-homebound',
    templateUrl: './auth-request-homebound.component.html',
    styleUrls: ['./auth-request-homebound.component.scss'],
    standalone: false
})
export class AuthRequestHomeboundComponent implements OnInit {
  @Output() isStepFormValid = new EventEmitter<boolean>();
  @Output() authRequestChanged = new EventEmitter<AuthorizationRequest>();
  @Input() requestType: string;
  @Input() authRequest: AuthorizationRequest;
  @Input() isPASCompleteFlow = false;

  homeboundForm: FormGroup;

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    // Build the Form
    this.buildHomeboundForm();

    // Form Subscriptions
    this.homeboundFormWatch();
    this.homeboundFormTeachableWatch();

    // Initial Form Validation Emit
    this.isStepFormValid.emit(this.homeboundForm.valid);
  }

  buildHomeboundForm() {
    const {
      isHomebound,
      familyFriendsAssistngWithCareYesResponse,
      familyOrFriendsAssistingWithCare
    } = this.authRequest.authorizationDTO;

    this.homeboundForm = new FormGroup({
      isHomebound: new FormControl(isHomebound, Validators.required),
      teachable: new FormControl(familyFriendsAssistngWithCareYesResponse?.toLowerCase(), Validators.required),
      careGiverDetail: new FormControl(familyOrFriendsAssistingWithCare, [Validators.maxLength(50), noWhiteSpaceValidator]),
    });
  }

  // Subscribe to homeboundForm
  homeboundFormWatch(): void {
    this.homeboundForm.valueChanges
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(val => {
      this.isStepFormValid.emit(this.homeboundForm.valid);
      this.loadAuthRequestFieldChanges(val);
      this.authRequestChanged.emit(this.authRequest);
    });
  }

  // Subscribe to homeboundForm control
  homeboundFormTeachableWatch(): void {
    this.homeboundForm.controls['teachable'].valueChanges
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => {
      const teachable = this.homeboundForm.get('teachable');
      const careGiverDetailControl = this.homeboundForm.get('careGiverDetail');

      if (teachable.value === 'yes') {
        careGiverDetailControl.setValue(null);

        if (!this.isPASCompleteFlow) {
          careGiverDetailControl.addValidators(Validators.required);
        }
      } else {
        careGiverDetailControl.removeValidators(Validators.required);
      }

      careGiverDetailControl.updateValueAndValidity();
    });
  }

  loadAuthRequestFieldChanges({ isHomebound, teachable, careGiverDetail }) {
    this.authRequest.authorizationDTO.isHomebound = isHomebound;
    this.authRequest.authorizationDTO.familyFriendsAssistngWithCareYesResponse = teachable;
    if (careGiverDetail) {
      this.authRequest.authorizationDTO.familyOrFriendsAssistingWithCare = careGiverDetail;
    }
  }

  removeValue() {
    this.authRequest.authorizationDTO.familyOrFriendsAssistingWithCare = '';
    this.homeboundForm.controls['careGiverDetail'].setValue('');
  }

}
